export default "__VITE_ASSET__4ac79e8e__"